// extracted by mini-css-extract-plugin
module.exports = {"title":"_3CKa8N","hint":"_1_xRp1","offers":"_1yURfu","chooseGiftCardValueModal":"_2YxDRD","offersItem":"_1y4rOB"};